import theme, { LOADED_THEME } from '@services/theme'

export default {
    iconColor: theme.palette.MuiLink,
    icons: {
        external: LOADED_THEME.link.externalIcon,
        internal: LOADED_THEME.link.internalIcon,
    }
}